/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExhibitionPageTransitionOptionsMorph,
    ExhibitionPageTransitionOptionsMorphFromJSON,
    ExhibitionPageTransitionOptionsMorphFromJSONTyped,
    ExhibitionPageTransitionOptionsMorphToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExhibitionPageTransitionOptions
 */
export interface ExhibitionPageTransitionOptions {
    /**
     * 
     * @type {ExhibitionPageTransitionOptionsMorph}
     * @memberof ExhibitionPageTransitionOptions
     */
    morph?: ExhibitionPageTransitionOptionsMorph;
}

export function ExhibitionPageTransitionOptionsFromJSON(json: any): ExhibitionPageTransitionOptions {
    return ExhibitionPageTransitionOptionsFromJSONTyped(json, false);
}

export function ExhibitionPageTransitionOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExhibitionPageTransitionOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'morph': !exists(json, 'morph') ? undefined : ExhibitionPageTransitionOptionsMorphFromJSON(json['morph']),
    };
}

export function ExhibitionPageTransitionOptionsToJSON(value?: ExhibitionPageTransitionOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'morph': ExhibitionPageTransitionOptionsMorphToJSON(value.morph),
    };
}


